// extracted by mini-css-extract-plugin
module.exports = {"root":"button_root__CxS4V","submit":"button_submit__0mid0","button":"button_button__bbIxr","loading":"button_loading__5z7Hc","disabled":"button_disabled__ULal_"};